// General types
export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const RESET_USER = "RESET_USER";
export const SET_CUSTOMER = "SET_CUSTOMER";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_ALERT = "SET_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";

// Vehicle Template types
export const SET_VEHICLE_TEMPLATE = "SET_VEHICLE_TEMPLATE";
export const CLEAR_VEHICLE_TEMPLATE = "CLEAR_VEHICLE_TEMPLATE";

// Reports Config types
export const SET_REPORT_CONFIG_TO_EDIT = "SET_REPORT_CONFIG_TO_EDIT";

// TODO cleanup device types

export const SET_DEVICE1 = "SET_DEVICE1";
export const SET_DEVICE2 = "SET_DEVICE2";

export const SET_VEHICLE = "SET_VEHICLE";
export const SET_DEVICE = "SET_DEVICE";

export const SET_PAGE = "SET_PAGE";

export const SET_TEMPLATE_PARAMETERS = "SET_TEMPLATE_PARAMETERS";

// Autosuggest types
export const SET_AUTOSUGGEST_DATA = "SET_AUTOSUGGEST_DATA";
export const RESET_AUTOSUGGEST_DATA = "RESET_AUTOSUGGEST_DATA";
export const RESET_AUTOSUGGEST_STATE = "RESET_AUTOSUGGEST_STATE";
